/**
 * @author      sam@zumper.com (Sam Sherman)
 * @copyright   Copyright (c) 2019, Zumper
 * @description optimizely constants
 */

export const ACCOUNT_CREATED = 'ACCOUNT_CREATED'
export const ALERT_CREATED = 'ALERT_CREATED'
export const BUBBLE_VIEW = 'BUBBLE_VIEW'
export const DETAIL_VIEW = 'DETAIL_VIEW'
export const DIRECT_DEAL_LEADS_SENT = 'DIRECT_DEAL_LEADS_SENT'
export const DIRECT_DEAL_MESSAGE_SENT = 'DIRECT_DEAL_MESSAGE_SENT'
export const DIRECT_DEAL_MULTI_MESSAGE_SENT = 'DIRECT_DEAL_MULTI_MESSAGE_SENT'
export const DIRECT_DEAL_PHONE_CALL = 'DIRECT_DEAL_PHONE_CALL'
export const DIRECT_DEAL_SINGLE_MESSAGE_SENT = 'DIRECT_DEAL_SINGLE_MESSAGE_SENT'
export const FILTERS_CLEAR = 'FILTERS_CLEAR'
export const FILTERS_SET = 'FILTERS_SET'
export const IMAGE_IMPRESSION_CAROUSEL = 'IMAGE_IMPRESSION_CAROUSEL'
export const LEAD_SENT = 'LEAD_SENT'
export const LIST_VIEW = 'LIST_VIEW'
export const LOCATION_SEARCHED = 'LOCATION_SEARCHED'
export const MAP_LIST_FILTER_BAR_CLICK = 'MAP_LIST_FILTER_BAR_CLICK'
export const MESSAGE_SENT = 'MESSAGE_SENT'
export const MESSAGE_SENT_MAPLIST = 'MESSAGE_SENT_MAPLIST'
export const MONETIZED_BUBBLE_VIEW = 'MONETIZED_BUBBLE_VIEW'
export const MONETIZED_DETAIL_VIEW = 'MONETIZED_DETAIL_VIEW'
export const MONETIZED_MESSAGE_SENT = 'MONETIZED_MESSAGE_SENT'
export const MONETIZED_MULTI_MESSAGE_SENT = 'MONETIZED_MULTI_MESSAGE_SENT'
export const MONETIZED_PHONE_CALL = 'MONETIZED_PHONE_CALL'
export const MONETIZED_SINGLE_MESSAGE_SENT = 'MONETIZED_SINGLE_MESSAGE_SENT'
export const MULTI_MESSAGE_SENT = 'MULTI_MESSAGE_SENT'
export const NO_LISTINGS_INCREASE = 'NO_LISTINGS_INCREASE'
export const NOTIFY_ME_CREATED = 'NOTIFY_ME_CREATED'
export const PHONE_CALL = 'PHONE_CALL'
export const PROPERTY_FAVORITED = 'PROPERTY_FAVORITED'
export const PROPERTY_SHARED = 'PROPERTY_SHARED'
export const PROPERTY_VIEW = 'PROPERTY_VIEW'
export const SEE_MORE_LISTINGS_CLICK = 'SEE_MORE_LISTINGS_CLICK'
export const SELECT_EXCLUSIVE_MESSAGE_SENT = 'SELECT_EXCLUSIVE_MESSAGE_SENT'
export const SELECT_EXCLUSIVE_MULTI_MESSAGE_SENT = 'SELECT_EXCLUSIVE_MULTI_MESSAGE_SENT'
export const SELECT_EXCLUSIVE_PHONE_CALL = 'SELECT_EXCLUSIVE_PHONE_CALL'
export const SELECT_EXCLUSIVE_SINGLE_MESSAGE_SENT = 'SELECT_EXCLUSIVE_SINGLE_MESSAGE_SENT'
export const SELECT_OPEN_MESSAGE_SENT = 'SELECT_OPEN_MESSAGE_SENT'
export const SELECT_OPEN_MULTI_MESSAGE_SENT = 'SELECT_OPEN_MULTI_MESSAGE_SENT'
export const SELECT_OPEN_PHONE_CALL = 'SELECT_OPEN_PHONE_CALL'
export const SELECT_OPEN_SINGLE_MESSAGE_SENT = 'SELECT_OPEN_SINGLE_MESSAGE_SENT'
export const SINGLE_MESSAGE_SENT = 'SINGLE_MESSAGE_SENT'
export const THIRD_PARTY_MESSAGE_SENT = 'THIRD_PARTY_MESSAGE_SENT'
export const THIRD_PARTY_MULTI_MESSAGE_SENT = 'THIRD_PARTY_MULTI_MESSAGE_SENT'
export const THIRD_PARTY_PHONE_CALL = 'THIRD_PARTY_PHONE_CALL'
export const THIRD_PARTY_SINGLE_MESSAGE_SENT = 'THIRD_PARTY_SINGLE_MESSAGE_SENT'
export const QUICK_LOOK_CLICK = 'QUICK_LOOK_CLICK'
export const VERTICAL_GALLERY_VIEW = 'VERTICAL_GALLERY_VIEW'
export const FOCUSED_GALLERY_VIEW = 'FOCUSED_GALLERY_VIEW'

// rich media
export const IFRAME_ENGAGEMENT = '3D_ENGAGEMENT'
export const IFRAME_IMPRESSION = '3D_IMPRESSION'
export const VIDEO_ENGAGEMENT = 'VIDEO_ENGAGEMENT'
export const VIDEO_IMPRESSION = 'VIDEO_IMPRESSION'
// Rent Specials
export const RENT_SPECIAL_EXPAND_CLICK = 'RENT_SPECIAL_EXPAND_CLICK'
export const CALL_FROM_STICKY_BAR = 'CALL_FROM_STICKY_BAR'
// Spotlight list cards
export const CLICK_LIST_CARD = 'CLICK_LIST_CARD'
export const CLICK_LIST_CARD_1 = 'CLICK_LIST_CARD_1'
export const CLICK_LIST_CARD_2 = 'CLICK_LIST_CARD_2'
export const CLICK_LIST_CARD_3 = 'CLICK_LIST_CARD_3'
export const CLICK_LIST_CARD_1_2_3 = 'CLICK_LIST_CARD_1_2_3'

// AI Assistant
export const ZOE_ENTRY_CLICK = 'ZOE_ENTRY_CLICK'
export const ZOE_ENTRY_IMPRESSION = 'ZOE_ENTRY_IMPRESSION'
export const ZOE_TOGGLE_CLICK = 'ZOE_TOGGLE_CLICK'
export const ZOE_DEFAULT_QUESTION_SUGGESTION_CLICK = 'ZOE_DEFAULT_QUESTION_SUGGESTION_CLICK'
export const ZOE_FOLLOW_UP_QUESTION_SUGGESTION_CLICK = 'ZOE_FOLLOW_UP_QUESTION_SUGGESTION_CLICK'
export const ZOE_QUESTION_SEND = 'ZOE_QUESTION_SEND'
export const ZOE_NO_RESULT = 'ZOE_NO_RESULT'
export const ZOE_CLOSE_CLICK = 'ZOE_CLOSE_CLICK'

// Map List Split Toggle
export const MAP_LIST_SPLIT_TOGGLE_CLICK = 'MAP_LIST_SPLIT_TOGGLE_CLICK'
export const PIN_CLICK = 'PIN_CLICK'
export const PIN_LISTING_CARD_CLICK = 'PIN_LISTING_CARD_CLICK'
export const FULL_WIDTH_MAP_IMPRESSION = 'FULL_WIDTH_MAP_IMPRESSION'

// Airbnb-friendly Internal Ad Module
export const AIRBNB_VIEW_PROPERTIES_CLICK = 'AIRBNB_VIEW_PROPERTIES_CLICK'
export const AIRBNB_LEARN_MORE_CLICK = 'AIRBNB_LEARN_MORE_CLICK'
